// apps/client/src/assets/builders/letter.ts — stationery envelope; params.wrapped → a wrapped gift box in the paper colour
import * as THREE from 'three';
import { RoundedBoxGeometry } from 'three/addons/geometries/RoundedBoxGeometry.js';
import { getItem, type PaperEntry } from '@whiskerton/content';
import { toyMaterial } from '../../characters/doll';
import type { CodeBuilder } from '../service';
export const builder: CodeBuilder = {
  id: 'letter',
  build(p) {
    const e = getItem(String(p.catalogId)) as PaperEntry;
    const g = new THREE.Group();
    if (p.wrapped) {
      const box = new THREE.Mesh(new RoundedBoxGeometry(0.3, 0.24, 0.3, 3, 0.04), toyMaterial(e.color)); box.position.y = 0.12;
      const ribbon = new THREE.Group(); ribbon.name = 'ribbon';
      ribbon.add(new THREE.Mesh(new THREE.BoxGeometry(0.31, 0.25, 0.05), toyMaterial('#F6C85F')), new THREE.Mesh(new THREE.BoxGeometry(0.05, 0.25, 0.31), toyMaterial('#F6C85F')));
      for (const s of [-1, 1]) { const bow = new THREE.Mesh(new THREE.SphereGeometry(0.05, 10, 8).scale(1.3, 0.8, 0.8), toyMaterial('#F6C85F')); bow.position.set(s * 0.05, 0.13, 0); ribbon.add(bow); }
      ribbon.position.y = 0.12;
      g.add(box, ribbon);
    } else {
      const env = new THREE.Mesh(new RoundedBoxGeometry(0.34, 0.02, 0.24, 2, 0.008), toyMaterial(e.color)); env.position.y = 0.01;
      const flap = new THREE.Mesh(new THREE.ConeGeometry(0.17, 0.12, 3).rotateX(-Math.PI / 2).scale(1, 0.12, 1), toyMaterial('#EAD6AE')); flap.position.set(0, 0.022, -0.04);
      g.add(env, flap);
    }
    return g;
  },
};
